module.exports = __webpack_public_path__ + "static/23-tat3-9813f147b02e74dd48379779dd478c76.jpg";